import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="font-mono text-neon-cyan animate-pulse-glow">Caricamento…</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
